module.exports = __webpack_public_path__ + "media/02.af2ca620.mp3";